import { FactoryProvider } from '@angular/core';

import { LogLevel } from '../../types';

type ILoggingServiceConstructor = new () => ILoggingService;
interface ILoggingService {
    /**
     * Save to the application's logs. (Requires outside service)
     * @param logObject? Object to save alongside the log message. Normally an error object.
     */
    Log: (message: string, logObject?: any, level?: LogLevel, isPrivate?: boolean) => void;

    DefaultLogLevel: LogLevel;
}

class LoggingService implements ILoggingService {

    DefaultLogLevel = LogLevel.Fatal;

    Log(message: string, logObject?: any, level?: LogLevel, isPrivate?: boolean) {
        level = level || this.DefaultLogLevel;
        switch (level) {
            case LogLevel.Verbose:
                isPrivate = isPrivate ? isPrivate : true;
                // tslint:disable-next-line:no-console
                console.debug(message, logObject);
                break;
            case LogLevel.Trace:
                isPrivate = isPrivate ? isPrivate : true;
                // tslint:disable-next-line:no-console
                console.debug(message, logObject);
                break;
            case LogLevel.Debug:
                isPrivate = isPrivate ? isPrivate : true;
                // tslint:disable-next-line:no-console
                console.debug(message, logObject);
                break;
            case LogLevel.Info:
                isPrivate = isPrivate ? isPrivate : false;
                // tslint:disable-next-line:no-console
                console.info(message, logObject);
                break;
            case LogLevel.Warn:
                isPrivate = isPrivate ? isPrivate : false;
                // tslint:disable-next-line:no-console
                console.warn(message, logObject);
                break;
            case LogLevel.Error:
                isPrivate = isPrivate ? isPrivate : false;
                // tslint:disable-next-line:no-console
                console.error(message, logObject);
                break;
            case LogLevel.Fatal:
                isPrivate = isPrivate ? isPrivate : true;
                // tslint:disable-next-line:no-console
                console.debug(message, logObject);
                break;
            default:
                isPrivate = isPrivate ? isPrivate : false;
                // tslint:disable-next-line:no-console
                console.log(message, logObject);
                break;
        }
        const applicationMessage = new CustomEvent('applicationMessage', { detail: { message, level, isPrivate }, composed: true });
        window.dispatchEvent(applicationMessage);
    }

    // TODO: Additional methods or properties?
}

const LoggingServiceProvider: FactoryProvider = {
    provide: 'LoggingService',
    useFactory: () => window.LoggingService ? new window.LoggingService() : new LoggingService()
};

export { LoggingServiceProvider, ILoggingService, ILoggingServiceConstructor };
